// src/services/presenceService.js
// Presencia en vivo por obra (placement): cada visitante que tiene el AR
// abierto para una escultura "hace ping" cada pocos segundos; los demás
// visitantes ven esa lista actualizarse en tiempo real vía onSnapshot.
import { collection, deleteDoc, doc, increment, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const HEARTBEAT_MS = 12000;
const STALE_MS = 30000;

const presenceCollection = (placementId) => collection(db, 'placementPresence', placementId, 'visitors');

export function joinPresence(placementId, visitorId, name) {
  if (!placementId || !visitorId) return () => {};
  const ref = doc(presenceCollection(placementId), visitorId);
  const ping = () => {
    setDoc(ref, { name: name || 'Explorador', lastSeenAt: serverTimestamp() }, { merge: true }).catch(() => {});
  };
  ping();
  const interval = setInterval(ping, HEARTBEAT_MS);
  return () => {
    clearInterval(interval);
    deleteDoc(ref).catch(() => {});
  };
}

export function subscribePresence(placementId, callback) {
  if (!placementId) return () => {};
  return onSnapshot(presenceCollection(placementId), (snap) => {
    const now = Date.now();
    const active = snap.docs
      .map((d) => ({ id: d.id, ...(d.data() || {}) }))
      .filter((v) => {
        const t = v.lastSeenAt?.toDate ? v.lastSeenAt.toDate().getTime() : now;
        return now - t < STALE_MS;
      });
    callback(active);
  }, () => callback([]));
}

export function incrementRestoredCount(placementId) {
  if (!placementId) return;
  setDoc(doc(db, 'placementStats', placementId), { timesRestored: increment(1) }, { merge: true }).catch(() => {});
}

export function subscribeRestoredCount(placementId, callback) {
  if (!placementId) return () => {};
  return onSnapshot(doc(db, 'placementStats', placementId), (snap) => {
    callback(snap.exists() ? Number(snap.data()?.timesRestored || 0) : 0);
  }, () => callback(0));
}
